import * as React from "react";
import { makeSimpleRoute } from "@ova-studio/react-hyper-admin";
const MediaIndex = React.lazy(() => import('./pages/MediaIndex'));
const MediaModuleConfig = {
    navigation: {
        order: 400,
        item: {
            url: '/media',
            icon: 'folder-multiple-image',
            name: 'Медіа',
        }
    },
    routes: [
        makeSimpleRoute({
            name: 'Медіа',
            path: 'media',
            element: React.createElement(MediaIndex, null),
        })
    ]
};
export default MediaModuleConfig;
//# sourceMappingURL=config.js.map